import { faHeart as faHeartLight } from "@jewlr/pro-light-svg-icons/faHeart"
import { faSpinner } from "@jewlr/pro-regular-svg-icons/faSpinner"
import { faHeart as faHeartSolid } from "@jewlr/pro-solid-svg-icons/faHeart"
import { createSelector } from "@reduxjs/toolkit"
import PropTypes from "prop-types"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import {
  addToWishlist,
  unselectFromWishlist,
} from "areas/collection/store/actions"
import { openModal } from "components/modal"
import Button from "components/ui/button"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import { IS_JEWLR, isTestMode } from "helpers/application"
import { cn } from "styles/utils"

const selectStyleCode = (state) =>
  state.choices.style_code && state.choices.style_code.value

const selectWishlistItems = (state) => state.wishlist.line_items

const selectWishlistAdded = createSelector(
  [selectStyleCode, selectWishlistItems],
  (styleCode, wishlistItems) =>
    wishlistItems?.some((li) => li.style_code === styleCode)
)

const Wishlist = ({ miniview }) => {
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const isLoggedIn = useSelector(
    (state) => Object.keys(state.user.jewlrorders).length > 0
  )
  const styleCode = useSelector(selectStyleCode)
  const wishlistAdded = useSelector(selectWishlistAdded)
  const wishlistLoading = useSelector((state) => state.wishlist.loading)

  const wishlistName = IS_JEWLR() ? "wish list" : "collection"
  const ariaLabel = loading
    ? `Loading ${wishlistName}`
    : isLoggedIn
      ? wishlistAdded
        ? `Remove from ${wishlistName}`
        : `Add to ${wishlistName}`
      : `Create a VIP account to add to your ${wishlistName}`

  const toggleAddToWishlist = (e) => {
    if (wishlistLoading) return null
    dispatch(
      wishlistAdded
        ? unselectFromWishlist(styleCode)
        : addToWishlist(styleCode, e.selected_look, "Product")
    )
  }

  useEffect(() => {
    if (!wishlistLoading) {
      setLoading(wishlistLoading)
    }
  }, [wishlistLoading])

  return (
    <Button
      aria-label={ariaLabel}
      className="border-grey-300 h-34 w-34 rounded-full border bg-white"
      disabled={loading}
      id={`add-wishlist-btn-${miniview ? "miniview" : "main"}`}
      onClick={(e) => {
        if (!isTestMode) {
          dataLayer.push({ event: "clicked-wishlist-icon" })
        }

        if (!IS_JEWLR() || isLoggedIn) {
          if (!loading) {
            setLoading(true)
            toggleAddToWishlist(e)
          }
        } else {
          openModal("#signup")
        }
      }}
      title={ariaLabel}
    >
      {loading ? (
        <FontAwesomeIcon className="text-20" icon={faSpinner} spin />
      ) : (
        <FontAwesomeIcon
          className={cn(
            "text-16",
            wishlistAdded ? "text-wishlist" : "text-black-print"
          )}
          icon={wishlistAdded ? faHeartSolid : faHeartLight}
        />
      )}
    </Button>
  )
}

Wishlist.propTypes = {
  miniview: PropTypes.bool,
}

export default Wishlist
